import { Injectable } from '@angular/core';
import { OperationsService } from '../base/operations.service';
import { GenberegnOperation } from './genberegn-operation';

@Injectable({
  providedIn: 'root',
})
export class GenberegnOperationsService extends OperationsService<GenberegnOperation> {
  addOperation(sagId: string, completeAfterIdleTimeout: number = null): GenberegnOperation {
    const operation = new GenberegnOperation(this._operations$, completeAfterIdleTimeout);
    operation.sagId = sagId;
    this._operations$.next([
      ...this._operations$.value.filter(x => !(x.sagId === sagId && !x.isProcessing)),
      operation,
    ]);
    return operation;
  }

  getOperation(sagId: string): GenberegnOperation {
    return this._operations$.value.find(x => x.sagId === sagId);
  }
}
